import React, { AriaRole } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { IconAnimationsOutline } from '@saucelabs/ds-icons';

import { TOOLBAR_TRACKING_NAMES, trackEvent } from '../../../tracking';
import * as globalActions from '../../../actions';
import * as globalSelectors from '../../../selectors';
import selectors from '../selectors';
import GenericButton from './GenericButton';

const AnimationsButton: React.FC<{ role?: AriaRole }> = ({ role }) => {
  const dispatch = useDispatch<ReduxDispatcher>();
  const {
    deviceToolsDisabled,
    deviceType,
    testType,
  } = useSelector(selectors.toolbarButtonSelector);
  const { animationsEnabled } = useSelector(globalSelectors.mobileSessionSelector);

  const toggleAnimations = () => {
    void dispatch(globalActions.toggleMobileDeviceAnimations());

    trackEvent(TOOLBAR_TRACKING_NAMES.ANIMATIONS, { deviceType, testType });
  };

  return (
    <GenericButton
      disabled={deviceToolsDisabled}
      icon={IconAnimationsOutline}
      label="Animations"
      onPress={toggleAnimations}
      role={role}
      status={animationsEnabled}
    />
  );
};

AnimationsButton.displayName = 'AnimationsButton';

export default AnimationsButton;
